import { masterDataTypes, manufacturerSubTabTypes } from '../constants/masterDataConstants';
import { getAgencyTypeLabel } from '../../../constants/agencyTypes';

/**
 * Determine which data type to use based on main tab and sub-tab
 */
export const getCurrentDataType = (currentType, manufacturerSubTab) => {
  if (currentType?.key === 'manufacturers') {
    return manufacturerSubTabTypes[manufacturerSubTab] || currentType;
  }
  return currentType;
};

/**
 * Get field label for table headers
 */
export const getFieldLabel = (field, currentType, manufacturerSubTab) => {
  if (field === 'assemblyType') return 'Assembly Type';
  if (field === 'name' && currentType.key === 'manufacturers' && manufacturerSubTab === 3) return 'Model Variant Name';
  if (field === 'name' && currentType.key === 'manufacturers' && manufacturerSubTab === 0) return 'Manufacturer Name';
  if (field === 'name' && currentType.key === 'manufacturers' && manufacturerSubTab === 2) return 'Primary Model Name';
  if (field === 'manufacturerNameId' && currentType.key === 'manufacturers' && manufacturerSubTab === 1) return 'Manufacturer Name';
  if (field === 'category' && currentType.key === 'manufacturers' && manufacturerSubTab === 1) return 'Aircraft Category';
  if (field === 'manufacturer' && currentType.key === 'manufacturers' && manufacturerSubTab === 2) return 'Manufacturer Name';
  if (field === 'manufacturer' && currentType.key === 'manufacturers' && manufacturerSubTab === 3) return 'Manufacturer Name';
  if (field === 'primaryModel' && currentType.key === 'manufacturers' && manufacturerSubTab === 3) return 'Primary Model';
  if (field === 'category' && currentType.key === 'manufacturers' && manufacturerSubTab === 2) return 'Aircraft Category';
  if (field === 'type' && currentType.key === 'manufacturers' && manufacturerSubTab === 2) return 'Aircraft Type';
  if (field === 'ataChapterId' && currentType.key === 'assembly-types') return 'ATA Chapter';
  if (currentType.key === 'agencies') {
    if (field === 'contactInfo') return 'Contact';
    if (field === 'types') return 'Types';
    if (field === 'certifications') return 'Certifications';
  }
  if (currentType.key === 'operators') {
    if (field === 'gmail') return 'Gmail';
    if (field === 'number') return 'Number';
    if (field === 'personToContact') return 'Person to Contact';
    if (field === 'template') return 'Template Header';
    if (field === 'workOrderFormTemplate') return 'WO Form Template';
  }
  return field.charAt(0).toUpperCase() + field.slice(1);
};

/**
 * Format cell value for table display
 */
export const formatCellValue = (item, field, currentType, manufacturerSubTab) => {
  if (field === 'columns') {
    return Array.isArray(item.columns) ? `${item.columns.length} column(s)` : '-';
  }
  
  if (field === 'name' && currentType.key === 'manufacturers' && manufacturerSubTab === 3) {
    return item.name || '-';
  }
  
  if (field === 'name' && currentType.key === 'manufacturers' && manufacturerSubTab === 0) {
    return item.name || '-';
  }
  
  if (field === 'name' && currentType.key === 'manufacturers' && manufacturerSubTab === 2) {
    return item.name || '-';
  }
  
  if (field === 'category' && currentType.key === 'manufacturers' && manufacturerSubTab === 1) {
    // Handle both string and object cases (object might come from cached/previous data)
    if (item.category && typeof item.category === 'object' && item.category !== null) {
      return item.category.category || String(item.category._id) || '-';
    }
    return item.category || '-';
  }
  
  if (field === 'category' && currentType.key === 'manufacturers' && manufacturerSubTab === 2) {
    if (item.category && typeof item.category === 'object' && item.category !== null) {
      return item.category.category || String(item.category._id) || '-';
    }
    return item.category || '-';
  }
  
  if (field === 'primaryModel' && currentType.key === 'manufacturers' && manufacturerSubTab === 3) {
    if (item.primaryModel && typeof item.primaryModel === 'object' && item.primaryModel !== null) {
      return item.primaryModel.name || String(item.primaryModel._id) || '-';
    }
    return '-';
  }
  
  if (field === 'manufacturer' && currentType.key === 'manufacturers' && (manufacturerSubTab === 2 || manufacturerSubTab === 3)) {
    if (item.manufacturer && typeof item.manufacturer === 'object' && item.manufacturer !== null) {
      return item.manufacturer.name || String(item.manufacturer._id) || '-';
    }
    return '-';
  }
  
  if (field === 'type' && currentType.key === 'manufacturers' && manufacturerSubTab === 2) {
    return item.type || '-';
  }
  
  if (field === 'ataChapterId' && currentType.key === 'assembly-types') {
    if (item[field] && typeof item[field] === 'object' && item[field] !== null) {
      return `${item[field].code || ''} - ${item[field].name || ''}`.trim() || '-';
    }
    return '-';
  }
  if (currentType.key === 'agencies') {
    if (field === 'types') {
      return Array.isArray(item.types) && item.types.length
        ? item.types.map(getAgencyTypeLabel).join(', ')
        : '-';
    }
    if (field === 'contactInfo') {
      const c = item.contactInfo;
      if (!c) return '-';
      if (typeof c === 'string') return c || '-';
      const parts = [c.email, c.phone, c.address].filter(Boolean);
      return parts.length ? parts.join(' · ') : '-';
    }
    if (field === 'certifications') {
      return Array.isArray(item.certifications) && item.certifications.length
        ? item.certifications.join(', ')
        : '-';
    }
  }
  if (currentType.key === 'operators') {
    if (field === 'personToContact') {
      return Array.isArray(item.personToContact) && item.personToContact.length
        ? item.personToContact.map((person) => `${person.name} (${person.number})`).join(', ')
        : '-';
    }
    if (field === 'template') {
      return item.templateFileName || (item.template ? 'Uploaded letterpad' : '-');
    }
    if (field === 'workOrderFormTemplate') {
      if (item.workOrderFormTemplate === 'GENERIC_PACKAGE') return 'Generic package';
      return 'CAME/FORM/04';
    }
  }
  if (typeof item[field] === 'object' && item[field] !== null) {
    return item[field].name || item[field].category || item[field].code || String(item[field]._id) || '-';
  }
  
  return item[field] !== undefined && item[field] !== null ? String(item[field]) : '-';
};
